import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import StudentRegistration from './StudentRegistration';
import SubscribeSection from './SubscribeSection';
import CustomDivider from '../../shared/utils/CustomDivider';
import KnowMoreSection from './KnowMoreSection';
import HeroSection from './HeroSection';
import TestimonialSection from './TestimonialSection';
import { Constants, Page_Padding } from '../../shared/constants';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox';
import { ImgText } from '../../shared/utils/Heading';
import { CustomButtonContained } from '../../shared/utils/CustomButton';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuthStore from '../../shared/store/useAuthStore';
import { useGetFooterDetail, useGetNavbarDetail } from '../../assets/nodeApi/getApi/ContentGetApi';
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta';
import CourseScroller from './CourseScroller';
import { COURSE_MAP } from '../../shared/utils/config';
import { useCourses } from '../../assets/api/useGetApi';
import SkillBoxScroller from './SkillBoxScroller';

const Home = ({ onLoadingChange }) => {
  // ✅ Use the new unified content + meta hook
  const { logout } = useAuthStore();
  const { data: homeData, isLoading: isHomeDataLoading } = usePageContentWithMeta("HOME");


  const { isLoading: isFooterDataLoading } = useGetFooterDetail();
  const { isLoading: isNavbarDataLoading } = useGetNavbarDetail();
  const allIsLoading = isFooterDataLoading || isNavbarDataLoading || isHomeDataLoading;
  const location = useLocation();
  const navigate = useNavigate();
  const { open, handleClickOpen, handleClose } = useDialog();
  useEffect(() => {
    if (location.state?.from === "/StudentLogin") {
      handleClickOpen();
    }
  }, [location.state, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectPath = params.get("redirect");
    if (redirectPath) {
      logout()
      navigate("/SelectLoginPath")
    }

  }, []);

  // ✅ Notify parent about loading state
  useEffect(() => {
    onLoadingChange(allIsLoading);
  }, [allIsLoading, onLoadingChange]);

  const { flatData: normalCourses, isLoading: isLoadingCourse } = useCourses({ course_type: "normal" }, 6);
  const { flatData: eventCourses, } = useCourses({ course_type: "event" }, 6);

  if (allIsLoading || !homeData?.content) return null;

  console.log(normalCourses,'normalCourses');
  

  return (
    <Box className="body home" px={Page_Padding}>
      <HeroSection content={homeData.content[0]} />
      <CustomDivider orientation='horizontal' />
      <CourseScroller content={homeData.content[1]} courses={normalCourses} isLoading={isLoadingCourse} category={COURSE_MAP.NORMAL_COURSES} />

      <CustomDivider orientation='horizontal' />
      <CourseScroller content={homeData.content[2]} courses={eventCourses} isLoading={isLoadingCourse} category={COURSE_MAP.EVENT} />
      <CustomDivider orientation='horizontal' />

      {/* Skill Box Session */}
      <SkillBoxScroller />
      <CustomDivider orientation='horizontal' />

      <KnowMoreSection content={homeData.content[3]} />
      <CustomDivider orientation='horizontal' />

      <SubscribeSection content={homeData.content[4]} />
      <CustomDivider orientation='horizontal' />

      <StudentRegistration content={homeData.content[5]} />
      <CustomDivider orientation='horizontal' />

      <TestimonialSection content={homeData.content[6]} />

      {/* — Welcome Dialog — */}
      <MainDialogBox
        open={open}
        handleClose={handleClose}
        width="60%"
        padding={0}
        sx={{ bgcolor: "transparent" }}
        isShowCross={false}
      >
        <Box
          sx={{
            backgroundImage: `url(${Constants.customImages.WelcomeImg})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100%",
            height: { xs: "500px", sm: "400px" },
            display: "flex",
            justifyContent: "center",
            alignItems: { xs: "center", sm: "end" },
          }}
        >
          <Box sx={{ height: "80%", width: "100%" }}>
            <Box
              sx={{
                height: "100%",
                width: '100%',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <ImgText text="Welcome to" sx={{ textAlign: "center", fontSize: { xs: "12px", sm: "20px" } }} />
              <ImgText text="MySkill Club" sx={{ textAlign: "center", fontSize: { xs: "20px", sm: "30px" } }} />
              <Typography
                variant='body2'
                color='grey.100'
                my={{ xs: 0, lg: 1 }}
                width="70%"
                textAlign="center"
                sx={{ fontSize: { xs: "10px", sm: "14px" }, lineHeight: { xs: "12px", sm: "20px" } }}
              >
                Unlock a world of fun, creativity, and learning designed just for kids!
              </Typography>
              <CustomButtonContained buttonText="Let's Get Started" onClick={handleClose} />
            </Box>
          </Box>
        </Box>
      </MainDialogBox>
    </Box>
  );
};

export default Home;
